import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { INPUT_LENGTH } from "../../../../../../../../../../constants";
export var unformatValue = function unformatValue(value) {
  if (!value) return '';
  return value.replace('+7', '').replace(/\D/g, '').slice(0, 10);
};
export var getUserType = function getUserType(accountNumber) {
  var isPhoneNumber = getIsPhoneNumber(accountNumber);
  if (isPhoneNumber) return 0;
  return 1;
};

/**
 * Applies a mask pattern to a string value by replacing underscores with characters
 *
 * Examples:
 * maskValue('9031112233', '+7 ___ ___ __ __') => '+7 903 111 22 33'
 * maskValue('903', '+7 ___ ___ __ __') => '+7 903'
 * maskValue('224', '_ + _ = _') => '2 + 2 = 4'
 */
export var maskValue = function maskValue(value, mask) {
  var remainingValue = value;
  var result = mask;

  // Replace each underscore with the next character from value
  for (var i = 0; i < mask.length && remainingValue.length > 0; i += 1) {
    if (mask[i] === '_') {
      result = result.substring(0, i) + remainingValue[0] + result.substring(i + 1);
      remainingValue = remainingValue.substring(1);
    }
  }

  // Remove any remaining underscores and trailing spaces
  return result.replace(/_/g, '').trimEnd();
};
export var getIsComplete = function getIsComplete(value) {
  return unformatValue(value).length >= 10;
};
var COUNTRY_CODE_DIGITS = [7, 8];
export var getIsPhoneNumber = function getIsPhoneNumber(value) {
  var _value = value.replace(/\D/g, '');
  return [6, 9].concat(COUNTRY_CODE_DIGITS) //
  .map(String).includes(_value[0]);
};
export var formatValue = function formatValue(value) {
  var phoneMask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+7 ___ ___ __ __';
  var nonPhoneMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '___ ___ ____';
  if (!value) return '';
  var _value = value.replace(/\D/g, '');
  var isPhoneNumber = getIsPhoneNumber(_value);
  if (!isPhoneNumber) return maskValue(_value, nonPhoneMask);
  var _phone = _value.replace(new RegExp("^[".concat(COUNTRY_CODE_DIGITS.toString(), "]")), '');
  return maskValue(_phone, phoneMask);
};
export var validateInput = function validateInput(value) {
  var texts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    empty: 'не может быть пустым',
    incomplete: 'введите полный номер' // FIXME: Constants
  };
  if (!value) return texts.empty;
  if (value.length < INPUT_LENGTH) return texts.incomplete;
  return undefined;
};

// Validates a phone number by checking completeness, format, and Beeline-specific errors.
// Returns an error message if validation fails, undefined if successful.
export var validateAccountNumber = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, getIsBeelineError, errorTexts) {
    var isComplete, validationError, isBeelineError, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          // Check if phone number has all required digits
          isComplete = getIsComplete(value); // Return early if number is incomplete
          if (isComplete) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", errorTexts.incomplete);
        case 4:
          // Validate the input format and emptiness
          validationError = validateInput(value, errorTexts); // Return any validation errors found
          if (!validationError) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", validationError);
        case 7:
          _context.next = 9;
          return getIsBeelineError(value);
        case 9:
          isBeelineError = _context.sent;
          error = isBeelineError; // Return Beeline-specific error if found
          if (!error) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return", error);
        case 13:
          return _context.abrupt("return", undefined);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](0);
          // Log any unexpected errors and return default error message
          console.error(_context.t0);
          return _context.abrupt("return", errorTexts.default);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 16]]);
  }));
  return function validateAccountNumber(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();